import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-issuesellerdispatchreportlist',
  templateUrl: './issuesellerdispatchreportlist.component.html',
  styleUrls: ['./issuesellerdispatchreportlist.component.scss']
})
export class IssuesellerdispatchreportlistComponent {
  sellerData: any[] = [];
  updateStatus: boolean = false;
  isLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IssuesellerdispatchreportlistComponent>
  ) {
    this.sellerData = data.sellerData;
    this.updateStatus = data.updateStatus;
    this.calculateTotalCopies();
  }
  // Inside your component class
totalCopies: number = 0;

// Call this after fetching or updating sellerData
calculateTotalCopies() {
  this.totalCopies = this.sellerData.reduce(
    (sum, item) => sum + (+item.issue_copies || 0),
    0
  );
}


  // Print only the table section
  print() {
    const printContents = document.getElementById('print-section')?.innerHTML;
    if (printContents) {
      const popupWin = window.open('', '_blank', 'width=1200,height=800');
      popupWin?.document.open();
      popupWin?.document.write(`
        <html>
          <head>
            <title>Dispatchwise Report</title>
            <style>
              table { border-collapse: collapse; width: 100%; }
              th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body onload="window.print(); window.close()">
            ${printContents}
          </body>
        </html>
      `);
      popupWin?.document.close();
    }
  }

  // Export as CSV
  exportExcel(fileName: string) {
    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent += 'Seller,Taluka,District,Representative,Copies\n';
    this.sellerData.forEach(row => {
      csvContent += `${row.issue_seller_id || ''},${row.taluka || ''},${row.district || ''},${row.representative_id || ''},${row.issue_copies || ''}\n`;
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
